// VIS-27: the one call for a quiet failure: a part of the map that did not load while the map goes on with a simpler
// stand-in or without it. Reported once per kind a page (errors.js reportDegraded, warning level, tag `degraded`).
// No side effect at import, so the modules that call it stay loadable in unit tests (node has no page: the report is
// then simply dropped). The kinds in use (docs/WORKFLOW.md "Error handling"): room-tour, building-model,
// building-interior, animals, ride-animals, people, landscape, forest, stars, button, painted-maps, drawing, ground-paint,
// ground-bake, clouds, baked-light, compile-helpers.
const seen = new Set();
let errors = null; // the import of errors.js, asked for once
/**
 * @param {string} area  what did not load (one of the kinds above)  @param {unknown} [err]  @param {Record<string, unknown>} [facts]
 */
export function degraded(area, err, facts) {
  if (seen.has(area)) return; // once per kind a page: a map with 40 buildings on their plain shape is one report
  seen.add(area);
  (errors ||= import('./errors.js')).then((m) => m.reportDegraded(area, err, facts)).catch(() => {}); // errors:ignore: reporting is best effort (and impossible outside a page)
}
